package com.gsb.vyapar.bhagya.presentation.common

import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.composed
import androidx.compose.ui.platform.LocalDensity
import kotlinx.browser.window
import org.w3c.dom.events.Event

actual fun Modifier.platformImePadding(): Modifier = composed {
    val density = LocalDensity.current
    var bottom by remember { mutableStateOf(0) }
    DisposableEffect(Unit) {
        val initialHeight = window.innerHeight
        val listener = { _: Event ->
            val diff = (initialHeight - window.innerHeight)
            bottom = if (diff > 0) diff else 0
        }
        window.addEventListener("resize", listener)
        onDispose { window.removeEventListener("resize", listener) }
    }
    padding(bottom = with(density) { bottom.toDp() })
}